export default "__VITE_ASSET__BjoTMg89__"